// Language URL-prefix mapping. English is the default (no prefix).
// Mapping:
//   /vn -> Vietnamese
//   /cn -> Chinese
//   /ko -> Korean
//   /fr -> French
//   /de -> German
//   /ru -> Russian
//   (no prefix) -> English

export const PREFIX_TO_LANG = {
  vn: "vi",
  cn: "zh",
  ko: "ko",
  fr: "fr",
  de: "de",
  ru: "ru",
};

export const LANG_TO_PREFIX = {
  en: "",
  vi: "vn",
  zh: "cn",
  ko: "ko",
  fr: "fr",
  de: "de",
  ru: "ru",
};

export const LANG_PREFIX_REGEX = /^\/(vn|cn|ko|fr|de|ru)(?=\/|$)/;

// Returns { prefix: "vn"|"cn"|... or "", lang: "vi"|"en"|... } from the current pathname.
export function detectLangFromPath(pathname = (typeof window !== "undefined" ? window.location.pathname : "/")) {
  const m = pathname.match(LANG_PREFIX_REGEX);
  if (m) {
    const prefix = m[1];
    return { prefix, lang: PREFIX_TO_LANG[prefix] || "en" };
  }
  return { prefix: "", lang: "en" };
}

// Returns a path stripped of any language prefix.
export function stripLangPrefix(pathname) {
  return pathname.replace(LANG_PREFIX_REGEX, "") || "/";
}

// Builds a full URL path with a given language prefix.
export function withLangPrefix(pathname, langCode) {
  const cleanPath = stripLangPrefix(pathname);
  const prefix = LANG_TO_PREFIX[langCode] || "";
  return (prefix ? `/${prefix}` : "") + (cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`);
}
